import { useTranslation } from "react-i18next";
import { Modal } from "@unified-checkout/design-system";
import { TrashIcon } from "@unified-checkout/design-system/icons/index";
import type { IButton } from "libs/design-system/src/types/Button/button";
import type { IDisConnectModal } from "@app/dashboard/types/innerLayout/xero/disconnect";

export const DisconnectModal = ({
    isModalOpen,
    setIsModalOpen,
    disconnectOrganizationMutate,
    disconnectOrganizationLoading
}: IDisConnectModal) => {
    const { t } = useTranslation();

    const btns = [
        {
            text: t('innerLayout.xeroPage.header.modal.disconnectOrganization'),
            size: "md",
            variant: "contained",
            color: "danger",
            onClickHandler: () => disconnectOrganizationMutate(),
            loading: disconnectOrganizationLoading
        } as IButton,
        {
            text: t('innerLayout.xeroPage.header.modal.cancel'),
            size: "md",
            variant: "outlined",
            color: "secondary",
            onClickHandler: () => setIsModalOpen(false)
        } as IButton
    ]

    return (
        <Modal
            state="danger"
            open={isModalOpen}
            position="center"
            onCloseHandler={() => setIsModalOpen(false)}
            headerIcon={TrashIcon}
            title={t('innerLayout.xeroPage.header.modal.title')}
            supportingText={t('innerLayout.xeroPage.header.modal.desc')}
            btnsProps={btns}
        />
    );
}

